export var FieldAttributes;
(function (FieldAttributes) {
    FieldAttributes["Required"] = "required";
    FieldAttributes["DataRequired"] = "data-iress-required";
    FieldAttributes["Name"] = "name";
    FieldAttributes["DisabledValidation"] = "disabled-validation";
    FieldAttributes["OptionalLabels"] = "optional-labels";
})(FieldAttributes || (FieldAttributes = {}));
export var FieldCssClass;
(function (FieldCssClass) {
    FieldCssClass["Base"] = "iress-field";
    FieldCssClass["Inline"] = "iress-field--inline";
    FieldCssClass["Stack"] = "iress-field--stack";
    FieldCssClass["Join"] = "iress-field--join";
    FieldCssClass["Invalid"] = "iress-field--invalid";
    FieldCssClass["Hint"] = "iress-field__hint";
    FieldCssClass["Errors"] = "iress-field__errors";
    FieldCssClass["InputContainer"] = "iress-field__input-container";
    FieldCssClass["InputInnerContainer"] = "iress-field__input-inner";
    FieldCssClass["Wrapper"] = "iress-field__wrapper";
    FieldCssClass["Legend"] = "iress-field__legend";
    FieldCssClass["Label"] = "iress-field__label";
})(FieldCssClass || (FieldCssClass = {}));
export var FieldTagTypes;
(function (FieldTagTypes) {
    FieldTagTypes["Fieldset"] = "fieldset";
    FieldTagTypes["Div"] = "div";
    FieldTagTypes["Legend"] = "legend";
    FieldTagTypes["Label"] = "iress-label";
})(FieldTagTypes || (FieldTagTypes = {}));
export var FieldSlot;
(function (FieldSlot) {
    FieldSlot["Hint"] = "hint";
})(FieldSlot || (FieldSlot = {}));
//# sourceMappingURL=field.types.js.map